if (!Array.prototype.first) {
  Array.prototype.first = function (callback) {
    for (var i = 0; i < this.length; ++i) {
      if (callback(this[i])) {
        return this[i];
      }
    }
    return null;
  };
}

if (!Array.prototype.toObject) {
  Array.prototype.toObject = function <T>(key: (x: T) => any, value: (x: T) => any): any {
    var data = this.map(x => [key(x), value(x)]);

    var result: any = {};
    for (let i = 0; i < data.length; ++i) result[data[i][0]] = data[i][1];
    return result;
  };
}

if (!Array.prototype.orderBy) {
  Array.prototype.orderBy = function <T>(this: T[], callback: (item: T) => any): T[] {
    return this.sort((a, b) => callback(a) > callback(b) ? 1 : -1);
  };
}

if (!Array.prototype.orderByDescending) {
  Array.prototype.orderByDescending = function <T>(this: T[], callback: (item: T) => any): T[] {
    return this.sort((a, b) => callback(a) < callback(b) ? 1 : -1);
  };
}

if (!Array.prototype.distinct) {
  Array.prototype.distinct = function (callback) {
    var distinct = [];
    var result = [];
    for (var i = 0; i < this.length; ++i) {
      var key = callback(this[i]);
      if (distinct.indexOf(key) === -1) {
        result.push(this[i]);
        distinct.push(key);
      }
    }
    return result;
  };
}

if (!Array.prototype.groupBy) {
  Array.prototype.groupBy = function <T, I>(this: T[], callback: (item: T) => I): { key: I, value: T[] } [] {
    const groups: { key: I, value: T[] }[] = [];

    for (let i = 0; i < this.length; ++i) {
      const item = callback(this[i]);
      let group = groups.first(x => x.key === item);
      if (group === null) {
        group = { key: item, value: [] };
        groups.push(group);
      }
      group.value.push(this[i]);
    }

    return groups;
  }
}

if (!Array.prototype.isEqualTo) {
  Array.prototype.isEqualTo = function (other: any[]): boolean {
    if (this.length !== other.length) return false;
    const _self = this.slice(0);
    const _other = other.slice(0);

    _self.sort();
    _other.sort();
    for (let i = 0; i < _other.length; ++i) {
      if (_self[i] !== _other[i]) return false;
    }
    return true;
  }
}

if (!Array.prototype.differences) {
  Array.prototype.differences = function (other: any[]): { added: any[], removed: any[], same: any[] } {
    const result = { added: [] as any[], removed: [] as any[], same: [] as any[] };

    // Check for same and removed
    for (let i = 0; i < this.length; ++i) {
      if (other.indexOf(this[i]) === -1) {
        result.removed.push(this[i]);
      } else {
        result.same.push(this[i]);
      }
    }

    // Check for added items
    for (let i = 0; i < other.length; ++i) {
      if (this.indexOf(other[i]) === -1) {
        result.added.push(other[i]);
      }
    }
    return result;
  }
}

if (!Array.prototype.findOne) {
  Array.prototype.findOne = function <T>(this: T[], callback: any) {
    for (var i = 0; i < this.length; ++i) {
      if (callback(this[i])) {
        return this[i];
      }
    }
    return null;
  };
}

if (!Array.prototype.remove) {
  Array.prototype.remove = function <T>(this: T[], item: any) {
    this.splice(this.indexOf(item), 1);
  };
}

if (!Array.prototype.removeAll) {
  Array.prototype.removeAll = function <T>(this: T[], callback: any) {
    const items = this.filter(callback);
    for (let i = 0; i < items.length; ++i) {
      this.remove(items[i]);
    }
  };
}

if (!Number.prototype.toArray) {
  Number.prototype.toArray = function <T>(initalizer: T): T[] {
    let result: T[] = [];
    for (let i = 0; i < this; ++i) result.push(initalizer);
    return result;
  }
}

if (!ArrayBuffer.prototype.convertToString) {
  ArrayBuffer.prototype.convertToString = function (): string {
    return String.fromCharCode.apply(null, new Uint8Array(this) as any);
  }
}

if (!String.prototype.splice) {
  String.prototype.splice = function (start: number, end: number, replace: string = ''): string {
    const left = this.slice(0, start);
    const right = this.slice(end);
    return `${left}${replace}${right}`;
  }
}

if (!String.prototype.format) {
  String.prototype.format = function (this: string, ...args: any): string {
    return this.replace(/{\d+}/g, (match, index) => {
      return args[index] ?? '';
    });
  }
}

if (!String.prototype.toKebab) {
  String.prototype.toKebab = function (this: string): string {
    const matches = this.match(/[A - Z]{2,}(?=[A-Z] [a-z0-9]*|\b)|[A-Z]?[a - z0 - 9]*|[A-Z]|[0-9]+/g);
    if (matches === null) return this;
    return matches
      .filter(Boolean)
      .map(x => x.toLowerCase())
      .join('-')
  }
}

if (typeof Object.deepCopy != 'function') {
  Object.defineProperty(Object, 'deepCopy', {
    value: function deepCopy(target: any): any {
      if (target === undefined || target === null) return null;
      let copy: any = {};
      let keys = Object.keys(target);
      for (let i = 0; i < keys.length; ++i) {
        if (target[keys[i]] !== undefined) {
          if (typeof target[keys[i]] === 'object') {
            copy[keys[i]] = Object.deepCopy(target[keys[i]]);
          } else {
            copy[keys[i]] = target[keys[i]];
          }
        }
      }
      return copy;
    },
    writable: true,
    configurable: true
  });
}

if (typeof Object.deepEqual != 'function') {
  Object.defineProperty(Object, 'deepEqual', {
    value: function deepEqual(lhs: any, rhs: any): boolean {
      if (lhs === undefined && rhs === undefined) return true;
      if (lhs === null && rhs === null) return true;
      if (lhs === undefined || lhs === null || rhs === undefined || lhs === null) return false;

      let equal = true;
      let keys = Object.keys(lhs);
      for (let i = 0; i < keys.length && equal; ++i) {
        if (lhs[keys[i]] !== undefined) {
          if (typeof lhs[keys[i]] === 'object') {
            equal = equal && Object.deepEqual(lhs[keys[i]], rhs[keys[i]]);
          } else {
            equal = equal && lhs[keys[i]] === rhs[keys[i]];
          }
        }
      }
      return equal;
    },
    writable: true,
    configurable: true
  });
}

if (typeof Object.merge != 'function') {
  Object.defineProperty(Object, 'merge', {
    value: function assign(target: any, mergeTarget: any) {
      function mergeTo(t: any, m: any) {
        var keys = Object.keys(t)
        if (typeof m === 'object') {
          keys = keys.concat(Object.keys(m)).distinct(function (x) { return x; });
        }
        var n: any = {};
        for (var i = 0; i < keys.length; ++i) {
          if (m[keys[i]] !== undefined) {
            switch (typeof t[keys[i]]) {
              case 'object':
                if (typeof m[keys[i]] === 'object') {
                  n[keys[i]] = mergeTo(t[keys[i]], m[keys[i]]);
                }
                else {
                  n[keys[i]] = m[keys[i]];
                }
                break;
              case 'function':
                break;
              default:
                n[keys[i]] = m[keys[i]];
                break;
            }
          }
          else {
            n[keys[i]] = t[keys[i]];
          }
        }
        return n;
      }

      return mergeTo(target, mergeTarget);
    },
    writable: true,
    configurable: true
  });
}

//#region Functional Overrides

//#endregion

export {};